import { create } from "zustand";

interface LoadingComponentStore {
    backdropOpen: boolean;

    // toggle: () => void;
    setVisibile: (val: boolean) => void;
}

export const useLoadingComponentStore = create<LoadingComponentStore>((set) => ({
    backdropOpen: false,

    setVisibile:( val: boolean) => set({backdropOpen: val})

    
}));